import React from 'react'
import { Box, LinearProgress } from '@mui/material'
import { ui } from '../../utils/uiTokens'

interface Props {
    value?: number
    width?: number
}

// Одна и та же полоса прогресса в списках групп и учеников
const ProgressBar: React.FC<Props> = ({ value = 0, width = 140 }) => {
    const percent = Math.min(100, Math.max(0, Math.round(value || 0)))

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <LinearProgress
                variant="determinate"
                value={percent}
                sx={{
                    width,
                    height: 8,
                    borderRadius: 999,
                    backgroundColor: ui.track,
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 999,
                        backgroundColor: percent === 100 ? ui.green : ui.pink,
                    },
                }}
            />

            <Box
                sx={{
                    minWidth: 44,
                    fontSize: '13px',
                    fontWeight: 600,
                    color: percent ? ui.ink : ui.muted,
                }}
            >
                {percent} %
            </Box>
        </Box>
    )
}

export default ProgressBar
